<template>
  <div style="margin: 10px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <el-row>
            <el-col :span="20">
              <el-form
                :inline="true"
                :model="form"
                class="demo-form-inline"
                size="mini"
              >
                <el-form-item>
                  <button
                    class="addAll"
                    @click="
                      $router.push({
                        path: '/home/Mparameter',
                        query: {
                          id: $route.query.id,
                        },
                      })
                    "
                  >
                    留言参数管理
                  </button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info">导出</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="2"></el-col>
          </el-row>
          <el-table
            size="mini"
            row-key="id"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            border
            :header-cell-style="{ background: '#E5E7EE', color: '#000000' }"
          >
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column
              align="center"
              :prop="dropCol[index].prop"
              :label="item.label"
              v-for="(item, index) in col"
              :key="`col_${index}`"
              :width="index == 0 ? '55' : ''"
            >
            </el-table-column>
            <el-table-column fixed="right" label="更多操作">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  icon="el-icon-info"
                  circle
                  size="small"
                  @click.native.prevent="update('update', scope.row.id)"
                ></el-button>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click.native.prevent="deleteRow(scope.$index, scope.row)"
                  size="small"
                ></el-button>
                <!-- 这里加按钮 -->
              </template>
            </el-table-column>
          </el-table>
          <div class="tableFooter">
            <button class="selectAll" @click="toggleSelection(tableData)">
              全选
            </button>
            <input
              type="button"
              class="del"
              value="批量删除"
              @click="selectDel"
            />
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '../../../assets/js/request.js'
import qs from 'qs'
export default {
  data () {
    return {
      tableData: [
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      multipleTable: [],
      loading: false,
      col: [{
        label: '编号',
        prop: 'id'
      },
      {
        label: '姓名',
        prop: 'name'
      },
      {
        label: '电话',
        prop: 'mobile'
      },
      {
        label: '提交时间',
        prop: 'addTime'
      },
      {
        label: 'Email',
        prop: 'email'
      }
      ],
      dropCol: [{
        label: '编号',
        prop: 'id'
      },
      {
        label: '姓名',
        prop: 'name'
      },
      {
        label: '电话',
        prop: 'mobile'
      },
      {
        label: '提交时间',
        prop: 'addTime'
      },
      {
        label: 'Email',
        prop: 'email'
      }
      ]
    }
  },
  created () {
    this.getData(this.currentPage, this.pageSize)
  },
  mounted () {
    this.rowDrop()
  },
  methods: {
    // 行拖拽
    rowDrop () {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      this.Sortable.create(tbody, {
        onEnd ({
          newIndex,
          oldIndex
        }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0]
          _this.tableData.splice(newIndex, 0, currRow)
        }
      })
    },
    // 获取列表数据
    getData (currentPage, pageSize) {
      this.loading = true
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/message/page',
        params: {

          pageNum: currentPage,
          pageSize: pageSize
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.loading = false
          this.tableData = res.data.data.data
          this.total = res.data.data.total
        } else {
          obj.$message.error(res.message)
        }
      })
    },
    update (iden, id) {
      this.$router.push({
        path: '/home/Mupdate',
        query: {
          iden: iden,
          id: id
        }
      })
    },
    deleteRow (index, rows) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        var obj = this
        obj.$http({
          method: 'get',
          url: 'api/v1/message/delete',
          params: {
            id: rows.id,
            uid: localStorage.getItem('uid')
          }
        }).then((res) => {
          if (res.data.status == 200) {
            this.loading = false
            obj.$message.success('删除成功')
            this.getData(this.currentPage, this.pageSize)
          } else {
            obj.$message.error(res.data.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 分页事件
    handleSizeChange (val) {
      this.pageSize = val // 将每页显示的条数 = 改变的值
      this.getData(this.currentPage, this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getData(this.currentPage, this.pageSize)
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 批量删除
    selectDel () {
      if (this.$refs.multipleTable.selection.length == 0) {
        this.$message.error('请选择要删除的表格信息！')
        return
      }
      var list = []
      for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
        list.push(this.$refs.multipleTable.selection[i].id)
      }
      this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        var obj = this
        obj.$http({
          method: 'get',
          url: 'api/v1/message/clear',
          params: {
            ids: list.toString(),
            uid: localStorage.getItem('uid')
          }
        }).then((res) => {
          if (res.data.status == 200) {
            this.loading = false
            obj.$message.success('删除成功')
            this.getData(this.currentPage, this.pageSize)
          } else {
            obj.$message.error(res.data.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped="scoped">
/deep/ .el-button--text {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7c96f8;
  line-height: 24px;
}

span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7c96f8;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/content/message/message.vue